import { render } from "./searchHumanityVideoList.vue?vue&type=template&id=a3d982e4&scoped=true"
import script from "./searchHumanityVideoList.vue?vue&type=script&lang=js"
export * from "./searchHumanityVideoList.vue?vue&type=script&lang=js"

import "./searchHumanityVideoList.vue?vue&type=style&index=0&id=a3d982e4&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\JzEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a3d982e4"]])

export default __exports__